import { NumericRanges } from '@src/features/settings/config/settings-constants';
import { UnitType } from '@src/core/enums';
import { MeasurementType, SETTING_MEASUREMENT_MAP } from '../../entities';
import { arcConvertUnit } from '@src/core/extensions';
import { useUnitType } from '../../units';

type NumericRange = { min: number; max: number };

const useNumericRanges = (): Record<string, NumericRange> => {
  const unitType = useUnitType();

  if (unitType === UnitType.SI) return NumericRanges;

  const converted: Record<string, NumericRange> = {};

  for (const [key, range] of Object.entries(NumericRanges)) {
    const type = SETTING_MEASUREMENT_MAP[key] ?? MeasurementType.NONE;
    converted[key] = {
      min: arcConvertUnit(range.min, type, unitType),
      max: arcConvertUnit(range.max, type, unitType),
    };
  }

  return converted;
};

export default useNumericRanges;
